import { injectQuery } from '@tanstack/angular-query-experimental'
import { injectCartoClient } from '../../ooh/services/carto.helper'
import { fetchCampaigns } from '../services/campaigns.service'

export { type CampaignRow } from '../services/campaigns.service'

export function injectCampaignsQuery() {
  const cartoClient = injectCartoClient()

  return injectQuery(() => ({
    queryKey: ['campaigns'],
    queryFn: async ({ signal }) => {
      return fetchCampaigns(cartoClient, signal)
    },
  }))
}
